<template>
  <div>
    <div>
      <Card class="col-12">
        <template #content>
          <div class="p-fluid formgrid grid d-flex mt-5">
            <div class="col-12 md:col-3">
              <label for="margem6" class="font-bold uppercase">{{
                labelMargem('margem6')
              }}</label>
              <InputNumber
                id="margem6"
                v-model="store.dados.margem6"
                mode="currency"
                currency="BRL"
                disabled />
            </div>

            <div class="field col-12 md:col-3">
              <label for="margem5" class="font-bold uppercase">{{
                labelMargem('margem5')
              }}</label>
              <InputNumber
                id="margem5"
                v-model="store.dados.margem5"
                mode="currency"
                currency="BRL"
                disabled />
            </div>

            <div class="field col-12 md:col-3">
              <label for="margem4" class="font-bold uppercase">{{
                labelMargem('margem4')
              }}</label>
              <InputNumber
                id="margem4"
                v-model="store.dados.margem4"
                mode="currency"
                currency="BRL"
                disabled />
            </div>

            <div v-if="!isViradaMargem" class="field col-12 md:col-3">
              <label for="margem3" class="font-bold uppercase">{{
                labelMargem('margem3')
              }}</label>
              <InputNumber
                id="margem3"
                v-model="store.dados.margem3"
                mode="currency"
                currency="BRL"
                disabled />
            </div>

            <div v-else class="field col-12 md:col-3">
              <label for="margem7" class="font-bold uppercase">{{
                labelMargem('margem7')
              }}</label>
              <InputNumber
                id="margem7"
                v-model="store.dados.margem7"
                mode="currency"
                currency="BRL"
                disabled />
            </div>
          </div>
        </template>
      </Card>
    </div>
  </div>
</template>

<script>
import { servidorStore } from '@/stores/servidor'
import Parametro from '@/domain/Parametro'
import ParametroService from '@/service/ParametroService.js'
import UtilService from '@/service/UtilService.js'

export default {
  setup() {
    const store = servidorStore()
    return { store }
  },

  data() {
    return {
      idMatricula: this.$route.params.id,
      parametro: new Parametro(),
      isViradaMargem: false,
    }
  },

  created() {
    this.parametroService = new ParametroService(this.$http)
    this.utilService = new UtilService(this.$http)
  },

  mounted() {
    this.carregarParametros()
    this.verificarViradaMargem()
  },

  methods: {
    async verificarViradaMargem() {
      this.isViradaMargem =
        await this.utilService.verificarViradaCartaoBeneficio()
    },
    labelMargem(chave) {
      let label = this.store.dados.configuracoes?.find(
        (el) => el.chave === chave,
      )

      if (chave === 'margem6') {
        if (this.parametro?.porcentagemMargem6) {
          return `Empréstimo  ${this.parametro.porcentagemMargem6}%`
        }
      } else if (chave === 'margem5') {
        if (this.parametro?.porcentagemMargem5) {
          return `Adiantamento  ${this.parametro.porcentagemMargem5}%`
        }
      } else if (chave === 'margem4') {
        if (this.parametro?.porcentagemMargem4) {
          return `Cartão  ${this.parametro.porcentagemMargem4}%`
        }
      } else if (chave === 'margem3') {
        if (this.parametro?.porcentagemMargem3) {
          return `Bens Duráveis  ${this.parametro.porcentagemMargem3}%`
        }
      } else if (chave === 'margem7') {
        if (this.parametro?.porcentagemMargem7) {
          return `Cartão de Benefícios  ${this.parametro.porcentagemMargem7}%`
        }
        return label?.valor || 'Cartão de Benefícios'
      }

      if (label) {
        return label?.valor
      }
      return chave
    },
    carregarParametros() {
      this.parametroService
        .getOneByMatriculaId(this.idMatricula)
        .then((res) => {
          this.parametro = res
        })
    },
  },
}
</script>
